module.exports = __webpack_public_path__ + "static/media/8.50a44819.jpg";